export function formatHeaderDate(date: Date): string {
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  });
}

export function formatTime(date: Date): string {
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });
}

export function getHourMarkers(): Date[] {
  const hours = [];
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  for (let i = 0; i < 24; i++) {
    currentDate.setHours(i);
    hours.push(new Date(currentDate));
  }

  return hours;
}

export function getEventPosition(startTime: string): number {
  const date = new Date(startTime);
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Each hour is 60px in height
  return hours * 60 + minutes;
}

export function getEventHeight(startTime: string, endTime: string): number {
  const start = new Date(startTime);
  const end = new Date(endTime);
  const durationInMinutes = (end.getTime() - start.getTime()) / (1000 * 60);

  // Each minute is 1px in height
  return durationInMinutes;
}

export function isToday(date: Date): boolean {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
}

export function getPreviousDay(date: Date): Date {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() - 1);
  return newDate;
}

export function getNextDay(date: Date): Date {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() + 1);
  return newDate;
}

export function getCurrentTimePosition(timezone?: string): number {
  const now = new Date();

  // Get time in specific timezone (or local if not provided)
  const options: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: timezone
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  const parts = formatter.formatToParts(now);

  const hours = Number(parts.find((p) => p.type === "hour")?.value ?? 0);
  const minutes = Number(parts.find((p) => p.type === "minute")?.value ?? 0);

  // Each hour = 60px
  return hours * 60 + minutes;
}

export function doEventsOverlap(
  event1Start: string,
  event1End: string,
  event2Start: string,
  event2End: string
): boolean {
  const start1 = new Date(event1Start).getTime();
  const end1 = new Date(event1End).getTime();
  const start2 = new Date(event2Start).getTime();
  const end2 = new Date(event2End).getTime();

  return start1 < end2 && start2 < end1;
}

export function getOverlappingGroups(events: any[]): any[][] {
  if (events.length === 0) return [];

  // Sort events by start time
  const sortedEvents = [...events].sort(
    (a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
  );

  const groups: any[][] = [];
  let currentGroup: any[] = [sortedEvents[0]];

  for (let i = 1; i < sortedEvents.length; i++) {
    const currentEvent = sortedEvents[i];
    let overlapsWithGroup = false;

    // Check if current event overlaps with any event in the current group
    for (const groupEvent of currentGroup) {
      if (
        doEventsOverlap(
          groupEvent.startTime,
          groupEvent.endTime,
          currentEvent.startTime,
          currentEvent.endTime
        )
      ) {
        overlapsWithGroup = true;
        break;
      }
    }

    if (overlapsWithGroup) {
      currentGroup.push(currentEvent);
    } else {
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = [currentEvent];
    }
  }

  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  return groups;
}
